// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"48c95b5c","18":"83556830","258":"98c154db","399":"5d0b4f7c","472":"48c95b5c","805":"cc1e3aa6","853":"d2fe489f","922":"48c95b5c"}[chunkId] + ".chunk.css";
};